import { LayoutResponseType } from '@app-store'
import { FieldValues } from 'react-hook-form'

export const fieldCache = new Map<string, FieldValues>()

export const layoutCache = new Map<string, LayoutResponseType>()
